export default __webpack_public_path__ + "static/2020s-ccc8ab9286977b732947839a361674ff.png";